import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import Link from '@/components/Link/Link';
import facebook from '@/public/social_icons/facebook.png';
import instagram from '@/public/social_icons/instagram.png';
import { devices } from '@/styles/breakpoints';

export const ArticleCard = ({ data }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image src={data.image} alt="article-data" />
      </ImageWrapper>

      <Title>
        {data.title} <MainTitle>{data.mainTitle}</MainTitle>
      </Title>
      <Button
        onClick={() =>
          window.open('https://app.orcatec.com/auth/signup', 'e_blank')
        }
        fullWidth={true}
        className="secondary"
      >
        Get Started Free
      </Button>
      <IconsBlock>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          locale={false}
          href="https://www.instagram.com/getorcatec/"
        >
          <Image src={instagram} width={24} height={24} alt="instagram" />
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          locale={false}
          href="https://www.facebook.com/people/GetOrcatec/100064292011425/"
        >
          <Image src={facebook} width={24} height={24} alt="facebook" />
        </Link>
      </IconsBlock>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  width: 100%;
  max-width: 400px;
  border-radius: 10px;
  background: #f6f7f9;
  @media only screen and ${devices.desktop} {
    padding: 24px;
    padding-top: 0;
    width: 360px;
    max-width: 360px;
  }
`;
const ImageWrapper = styled.div``;

const Title = styled.h2`
  font-size: 24px;
`;

const MainTitle = styled.span`
  color: #206fed;
`;
const IconsBlock = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  & img {
    width: 24px !important;
    height: 24px !important;
  }
`;
